export default __webpack_public_path__ + "static/Ristoranti-c962174e16868d8d0cd097194433bd31.jpg";